import { useState, useEffect } from "react";
import { Outlet, useLocation } from "react-router-dom";
import { Menu, Calculator, CalendarDays, Clock3 } from "lucide-react";
import Sidebar from "./Sidebar";
import ToolsDrawer from "@/components/tools/ToolsDrawer";
import { Sheet, SheetContent } from "@/components/ui/sheet";

function MiniClock() {
  const [now, setNow] = useState(new Date());
  useEffect(() => { const t = setInterval(() => setNow(new Date()), 1000); return () => clearInterval(t); }, []);
  return (
    <div className="hidden sm:flex flex-col items-end leading-tight" data-testid="topbar-clock">
      <span className="font-mono text-sm text-slate-100">{now.toLocaleTimeString("en-GB", { timeZone: "Asia/Riyadh" })}</span>
      <span className="text-[11px] text-slate-500">{now.toLocaleDateString("ar-SA", { weekday: "long", day: "numeric", month: "long" })}</span>
    </div>
  );
}

const TOOLS = [
  { id: "calculator", icon: Calculator, label: "الآلة الحاسبة" },
  { id: "calendar", icon: CalendarDays, label: "التقويم" },
  { id: "clock", icon: Clock3, label: "الساعة العالمية" },
];

export default function Shell() {
  const [tool, setTool] = useState(null);
  const [mobileNav, setMobileNav] = useState(false);
  const loc = useLocation();
  useEffect(() => setMobileNav(false), [loc.pathname]);

  return (
    <div className="h-screen flex overflow-hidden">
      <div className="hidden lg:block shrink-0"><Sidebar /></div>
      <Sheet open={mobileNav} onOpenChange={setMobileNav}>
        <SheetContent side="right" className="p-0 w-72 bg-[#090D16] border-white/10">
          <Sidebar onNavigate={() => setMobileNav(false)} />
        </SheetContent>
      </Sheet>

      <div className="flex-1 flex flex-col min-w-0">
        <header className="h-16 shrink-0 flex items-center justify-between gap-3 px-4 sm:px-6 border-b border-white/[0.06] bg-[#080C14]/80 backdrop-blur-md">
          <div className="flex items-center gap-2">
            <button data-testid="mobile-menu-button" onClick={() => setMobileNav(true)} className="lg:hidden h-10 w-10 grid place-items-center rounded-xl bg-white/5 text-slate-200"><Menu size={20} /></button>
            <div className="flex items-center gap-1 rounded-xl bg-white/[0.04] p-1 border border-white/[0.06]">
              {TOOLS.map((t) => (
                <button key={t.id} data-testid={`agent-tool-${t.id}-toggle`} title={t.label} onClick={() => setTool(tool === t.id ? null : t.id)}
                  className={`h-8 px-2.5 rounded-lg text-xs flex items-center gap-1.5 transition-colors ${tool === t.id ? "bg-cyan-400/15 text-cyan-200" : "text-slate-400 hover:text-white hover:bg-white/5"}`}>
                  <t.icon size={15} /> <span className="hidden md:inline">{t.label}</span>
                </button>
              ))}
            </div>
          </div>
          <MiniClock />
        </header>
        <main className="flex-1 min-h-0 overflow-y-auto">
          <Outlet />
        </main>
      </div>

      <ToolsDrawer tool={tool} onClose={() => setTool(null)} />
    </div>
  );
}
